import { PipeTransform, Pipe } from '@angular/core';
import { spaceCapCase } from './spaceCapCase.pipe';
@Pipe({
  name: 'spaceCapCaseToLower',
  standalone: false
})
export class SpaceCapCaseToLowerPipe implements PipeTransform {
  transform(str: string) {
    return spaceCapCaseToLower(str);
  }
}

export function spaceCapCaseToLower(str: string): string {
  return spaceCapCase(str).toLowerCase();
}
